export const Logo = ({ variant = "dark", size = "default" }) => {
  const isDark = variant === "dark";
  const isGold = variant === "gold";
  const isLarge = size === "large";

  const baseColor = isDark ? "text-gray-900" : "text-white";
  const accentGradient = isGold
    ? "bg-gradient-to-r from-[#FFE5A8] via-[#F5C77A] to-[#E0A954]"
    : "bg-gradient-to-r from-pink-400 to-rose-500";
  const scriptColor = isGold ? "text-[#F5C77A]" : "text-pink-400";

  return (
    <span className="inline-flex flex-col leading-none select-none" data-testid="logo-text">
      <span
        className={`font-black tracking-tight ${baseColor} ${isLarge ? 'text-3xl sm:text-4xl' : 'text-xl sm:text-2xl'}`}
        style={{ fontFamily: "'Lilita One', cursive", lineHeight: 1.1 }}
      >
        YU<span className={`text-transparent bg-clip-text ${accentGradient}`}>CC</span>A
      </span>
      <span
        className={`${scriptColor} font-semibold ${isLarge ? 'text-lg sm:text-xl -mt-2' : 'text-sm sm:text-base -mt-1.5'}`}
        style={{ fontFamily: "'Dancing Script', cursive", lineHeight: 1 }}
      >
        flowers
      </span>
    </span>
  );
};

export default Logo;
